export default __webpack_public_path__ + "static/media/au_ohos.ba71c7f5.svg";